<template>
  <ul class="category-list">
    <li>
      <router-link to="/category/all">
        <span class="left-content">{{ $t('Blog.all') }}</span>
        <span class="count-text">{{ posts.length }}</span>
      </router-link>
    </li>
    <li v-for="(category, index) in categories" :key="`${category.slug}-${index}`">
      <router-link :to="`/category/${category.slug}`">
        <span class="left-content">{{ $t('Blog.categories.' + category.title) }}</span>
        <span class="count-text">{{ category.count }}</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
import BlogPostMixin from '../../mixins/BlogPostMixin'

export default {
  name: 'BlogCategories',
  mixins: [BlogPostMixin]
}
</script>
